import React, { Component } from 'react';
import { Alert, Collapse, Modal, Row, Col } from 'react-bootstrap';
import { Form, Input } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import Parse from 'parse'

import ReactGA from "react-ga";
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

import { Center, ImageSection, LogeButton, Icon, Black, ModalHeading } from '../../GeneralStyle'

import headerImage from '../../../images/modal/tl_header_bewerbung.jpg';

/* Imports for Image Upload Field */
import Dropzone from 'react-dropzone'
import { DoubleBounce } from 'better-react-spinkit'
import { DropzoneDiv } from '../../internal/BlackboardBlog/BlackboardStyle'
import axios from 'axios'
import config from 'react-global-configuration';

const STATE = { LOADING: 'loading', ERROR: 'error', DEFAULT: 'default', SUCCESS: 'success' }

@inject('partnerInformationStore')
@observer
class UpdatePartnerContactModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      state: STATE.DEFAULT,
      image_state: STATE.DEFAULT,
      image_id: props.partner && props.partner.logo,
      image_error: undefined,
    }
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.partner !== this.props.partner)
      this.setState({ image_id: this.props.partner && this.props.partner.logo })
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  openModal = () => {
    this.setState({ showModal: true });
  }

  onDrop = (file) => {

    if(!file[0]) {
      this.setState({image_state: STATE.ERROR, image_error: "Es wurde keine gültige Datei ausgewählt!"})
      return
    }

    this.setState({
      image_state: STATE.LOADING,
      image_error: undefined,
    });

    let formData = new FormData()

    formData.append('file', file[0])
    formData.append("tags", `theloge, blog`)
    formData.append("upload_preset", config.get("CLOUDINARY_PRESET"))
    formData.append("timestamp", (Date.now() / 1000) | 0)

    axios.post(config.get("CLOUDINARY_UPLOAD_URL"), formData, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    }).then(response => {
      this.setState({
        image_state: STATE.SUCCESS,
        image_id: response.data.public_id,
      });
    }).catch(err => {
      console.error("err", err)

      this.setState({
        image_state: STATE.ERROR
      });
    })
  }

  onSubmit = async (data) => {
    this.setState({state: STATE.LOADING})
    data.logo = this.state.image_id
    try {
      const res = await Parse.Cloud.run("updatePartnerLogo", data)
      this.closeModal()
      this.setState({state: STATE})
      this.props.partnerInformationStore.loadPartnerFromShortname(this.props.partner.shortname)
      this.props.partnerInformationStore.checkRequiredInformation()
    } catch (e) {
      this.setState({state: STATE.ERROR})
      console.error(e);
    }
  }


  render() {
    const isDefaultRequiredValue = 'Das ist ein Pflichtfeld.'

    const partner = this.props.partner


    const UploadImage = () => {

      const Loading = () => {
        return (
          <p style={{ color: 'black', marginBottom: 0}}><DoubleBounce  color={"#DAB777"} size={60} /></p>
        )
      }

      const ErrorText = () => {
        return (
          <p style={{ color: 'red', marginBottom: 0 }}>{ this.state.image_error || "Es ist ein unerwarteter Fehler aufgetreten! Bitte versuchen Sie es erneut."}</p>
        )
      }

      const DefaultText = () => {
        return (
          <p style={{ color: 'black', marginBottom: 0 }}>Laden Sie Ihr Firmen-Logo hoch.</p>
        )
      }

      const SuccessText = () => {
        return (
          <p style={{ color: 'black', marginBottom: 0 }}>Firmen-Logo erfolgreich hochgeladen!</p>
        )
      }

      return (
        <div>
          <Dropzone
            id="dropzone"
            multiple={false}
            accept="image/*"
            onDrop={this.onDrop}
            maxSize={3000000}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: 'column',
              flex: 1,
              border: '3px dashed #999',
              height: 250,
              padding: 20,
              marginTop: 20,
              cursor: 'pointer',
            }}
          >
            { this.state.image_state !== STATE.LOADING &&
              <img
                style={{ width: 'auto', height: 150, marginBottom: 20, width: 150, borderRadius: '50%', objectFit: 'contain' }}
                src={`${config.get('CLOUDINARY_URL')}${ this.state.image_id || "default-logo_gzpkqk"}.jpg`}
              />
            }
            {
              this.state.image_state === STATE.LOADING ?
                <Loading />
              : this.state.image_state === STATE.ERROR ?
                <ErrorText />
              : this.state.image_state === STATE.SUCCESS ?
                <SuccessText />
              :
                <DefaultText />
            }

          </Dropzone>
          <p style={{ color: 'black', marginTop: 20, width: '100%', textAlign: 'center' }}>Ziehe oder klicke, um ein Bild der Formate JPG oder PNG hochzuladen.</p>
        </div>
      )
    }


    const DataForm = () => {
      return (
        <Form
          onSubmit={this.onSubmit}
          layout={'vertical'}
          validateOnSubmit={true}
          validatePristine={false}
          disabled={ this.state.state === STATE.LOADING }
          className="partner-modal-form"
        >
          <Col sm={12}>
            <UploadImage />
          </Col>
          { this.state.state === STATE.ERROR && <Col sm={12} style={{color: "red", textAlign: "center", paddingTop: 20}}>Es ist ein Fehler aufgetreten.</Col> }
          <Center marginTop={60} marginBottom={30}>
            <LogeButton
              hoverFontColor={"white"}
              type="submit"
              style={{ marginTop: 30}}
              disabled={ this.state.state == STATE.LOADING || this.state.image_state == STATE.LOADING }
            >
              Daten speichern
            </LogeButton>
          </Center>
        </Form>
      )
    }

    return (

      <Modal show={this.state.showModal} onHide={this.closeModal}>
        <ImageSection background={ headerImage }>
          <Modal.Header closeButton>
            <Modal.Title>
              <div><ModalHeading>Logo Ihrer Firma</ModalHeading></div>
            </Modal.Title>
          </Modal.Header>
        </ImageSection>
        <Modal.Body>
          <DataForm />
        </Modal.Body>
      </Modal>
    );
  }

}

export default withRouter(UpdatePartnerContactModal)



// WEBPACK FOOTER //
// /src/components/partner/modals/UpdatePartnerLogoModal.js